<template lang="pug">
  select.square-input(:value='value', :required='dropdown.required', @change="updateItem($event.target.value)")
    option(:value='option.value', v-for='(option, optionKey) in dropdown.options', :key='optionKey', :disabled='option.disabled') {{ $t(option.label) }}
</template>

<script>
import _ from 'lodash'

export default {
  props: ['id', 'itemId'],
  data () {
    return {
      item: this.$store.getters['quote/getItem'](this.itemId)
    }
  },
  computed: {
    value () {
      this.$forceUpdate() // Hack to update the dropdown
      return this.item[this.id]
    },
    dropdown () {
      const dropdowns = this.$store.getters['quote/dropdowns']
      const dropdown = dropdowns[this.id]

      if (_.isUndefined(dropdown)) { return [] }

      return {
        ...dropdown,
        options: _.filter(dropdown.options, (option, index) => {
          if (_.isUndefined(option.show)) { return true }

          let and = true

          for (const andCondition of option.show) {
            for (const orCondition of andCondition) {
              let or = false
              _.forEach(orCondition, (itemValues, itemKey) => {
                if (itemValues.indexOf(this.item[itemKey]) !== -1) {
                  or = true
                }
              })
              if (or !== true) { and = false }
            }
          }

          return and
        })
      }
    }
  },
  methods: {
    updateItem (value) {
      const obj = {}
      obj[this.id] = value

      this.$store.dispatch('quote/updateItem', { ...obj, id: this.itemId })

      if (this.id === 'solutionType') {
        const itemObj = {
          id: this.itemId,
          materialType: 'economical',
          paintType: 'no-paint',
          paintColor: 'none',
          postProcessOptions: 'none'
        }

        switch (value) {
          case 'economical':
            itemObj.materialType = 'economical'
            itemObj.finishLevel = 'strip-and-ship'
            break
          case 'quickest-delivery':
            itemObj.materialType = 'quickest-delivery'
            itemObj.finishLevel = 'strip-and-ship'
            break
          case 'sla':
            itemObj.materialType = 'any-resin'
            itemObj.finishLevel = 'strip-and-ship'
            break
          case 'sls':
            itemObj.materialType = 'nylon12'
            itemObj.finishLevel = 'strip-and-ship'
            break
          case 'dmls':
            itemObj.materialType = 'any-steel'
            itemObj.finishLevel = 'basic'
            break
          case 'polyjet':
            itemObj.materialType = 'veroWhite'
            itemObj.finishLevel = 'strip-and-ship'
            break
          case 'fdm':
            itemObj.materialType = 'any-filament'
            itemObj.finishLevel = 'strip-and-ship'
            break
        }

        this.$nextTick(() => this.$store.dispatch('quote/updateItem', itemObj))
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
